import { SamplingDecision, } from '@opentelemetry/sdk-trace-base';
export class CxCustomSampler {
    shouldSample() {
        return {
            decision: SamplingDecision.RECORD, // RECORDED BUT SAMPLED = 00
        };
    }
}
